<!-- signup -->
<div
  class="content m-0 signin auth-page auth-page-wide"
  [ngClass]="{ 'h-100': logflag }"
>
  <div
    class="row"
    [ngClass]="{
      'mt-0': step == 3,
      'mt-sm-0': step === 1 || step === 2 || step === 4,
      'signin-row': step === 1 || step === 2 || step === 4
    }"
  >
    <div
      class="col-12 col-sm-8 col-md-9 col-lg-7 offset-sm-2 offset-md-1 px-sm-0"
    >
      <h1 class="text-center text-md-left title mt-sm-0 mt-3">
        <span *ngIf="step == 1">Create your account</span>
        <span *ngIf="step == 2">Confirm your email</span>
        <span *ngIf="step == 4">Create your account</span>
        <span *ngIf="step == 3">Finish setting up your account</span>
        <span *ngIf="step == 5">Review your display name</span>
      </h1>
      <p
        class="signup-step-label text-center text-md-left mb-0 mt-2"
        *ngIf="step == 1 || step == 2 || step == 4"
      >
        Account step {{ onboardingStep }} of {{ onboardingTotalSteps }}
      </p>
      <div
        class="progress signup-progress-bar mt-3"
        *ngIf="step == 1 || step == 2 || step == 4"
      >
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="onboardingProgressPercent"
          [attr.aria-valuenow]="onboardingProgressPercent"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  </div>
  <!-- Signup step == 1 -->
  <div class="row mt-sm-0 mt-2 m-0 pb-2 center" *ngIf="step == 1">
    <div
      class="col-12 col-sm-8 col-md-9 col-lg-7 offset-sm-2 offset-md-1 px-sm-0"
    >
      <!-- <div class="col-md-12 pl-0 d-flex">
        <div class="col-8 px-0">
          <p class="py-1 sub-title fw-600 font-14">* Please use your <span class="sub-title fw-900 font-14 text-danger">Full Legal Name</span> as shown on your government issued ID when creating your CitizeX account</p>
        </div>
        <div class="col pr-md-3 pr-0">
          <img src="../../../assets/images/Id_img.png" class="id-img py-1">
        </div>
      </div> -->
      <!-- <div class="col-md-12 pl-0 mt-2">
        <p class="font-16 fw-600 text-danger">Use Your Full Legal Name</p>
        <p class="fw-500">Enter your name exactly as it appears on your government-issued ID, including all prefixes (e.g., Dr., Mr.) and suffixes (e.g., Jr., Sr.).</p>
        <p class="fw-500 mt-2"><span class="fw-600">Example:</span><br/>
            ID Name: Dr. John Michael Smith Jr.<br/>
            Enter as:<br/>
            First Name: Dr. John Michael<br/>
            Last Name: Smith Jr.<br/>
        </p>
      </div> -->
      <div class="col-12 p-0 pr-md-3 mt-3">
        <p class="text-center text-md-left py-1 sub-title">
          All new passwords must contain at least 8 characters. There must be at
          least one capital and one lower-case letter (Aa-Zz), one special
          symbol (#, &, % etc), and one number (0-9) in your password for the
          best strength.
        </p>
      </div>
      <form
        class="row m-0 square-form needs-validation cx-standard-form"
        (ngSubmit)="(f.form.valid)"
        #f="ngForm"
        novalidate
      >
        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="f.submitted && f.touched && f.invalid"
        >
          Please fill up all the details correctly.
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <!-- .alert-dangers -->

        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="invalidSignUp == true"
        >
          {{ errMsg }}
          <button
            type="button"
            (click)="invalidSignUp = false"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>

        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="recaptchaErrorMessage"
        >
          {{ recaptchaErrorMessage }}
          <button
            type="button"
            (click)="recaptchaErrorMessage = ''"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>

        <!-- .alert-dangers -->
        <!-- <div class="col-md-6 p-0 pr-md-3">
          <div class="form-group">
            <input type="text" [ngClass]="{ 'form-control': true, 'has-value': !!fname.value }" id="firstName"
              name="firstname" #fname="ngModel" [(ngModel)]="user.firstName" tabindex="1" required  NoLeadingWhitespace/>
            <label for="firstName">First & Middle Name*</label>
            <div class="invalid-feedback" *ngIf="f.submitted && fname.invalid">
              <span *ngIf="fname.errors?.['required']">
                Please enter First & Middle Name.</span>
              <span *ngIf="fname.errors?.['pattern']">
                Please enter Valid First & Middle Name.</span>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-md-6 p-0 pr-md-3">
          <div class="form-group">
            <input type="text" [ngClass]="{ 'form-control': true, 'has-value': !!lname.value }" id="lastname"
              name="lastname" #lname="ngModel" [(ngModel)]="user.lastName" tabindex="2" required  NoLeadingWhitespace/>
            <label for="lastname">Last Name*</label>
            <div class="invalid-feedback" *ngIf="f.submitted && lname.invalid">
              <span *ngIf="lname.errors?.['required']">
                Please enter Last Name.</span>
              <span *ngIf="lname.errors?.['pattern']">
                Please enter Valid Last Name.</span>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-md-12 p-0 pr-md-3 align-self-start">
          <div class="form-group">
            <div class="right-icon"></div>
            <ejs-datepicker
              #DOB
              id="DOB"
              name="DOB"
              #dob="ngModel"
              placeholder="MM-DD-YYYY"
              [(ngModel)]="user.dateOfBirth"
              [max]="maxDate"
              format="MM-dd-yyyy"
              start="Decade"
              depth="Month"
              strictMode="true"
              aria-placeholder="YYYY-MM-DD"
              [htmlAttributes]="{ inputmode: 'none' }"
              [ngClass]="{ 'form-control': true, 'has-value': !!dob.value }"
              (focus)="$event.model.show()"
              (change)="checkDOB($event)"
              tabindex="3"
              required
            ></ejs-datepicker>
            <label for="DOB">Date of birth*</label>

            <div class="invalid-feedback" *ngIf="f.submitted && dob.invalid">
              <span *ngIf="dob.errors.required"> Please enter Date Of Birth.</span>
            </div>
            <div class="invalid-feedback" *ngIf="this.validAge == false">
              <span *ngIf="this.validAge == false">Your age should be 18+</span>
            </div>
          </div>
        </div> -->
        <!-- .col -->

        <div class="col-md-12 p-0 pr-md-3">
          <div class="form-group">
            <label for="emailID"
              >Email Address <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              [ngClass]="{ 'form-control': true, 'has-value': !!emailId.value }"
              id="emailID"
              name="emailID"
              pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9]+([\-\.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$"
              #emailId="ngModel"
              [(ngModel)]="user.email"
              required
              NoLeadingWhitespace
            />
            <div
              class="invalid-feedback"
              *ngIf="f.submitted && emailId.invalid"
            >
              <span *ngIf="emailId.errors?.['required']">
                Please enter Email address.
              </span>
              <span *ngIf="emailId.errors?.['pattern']">
                Please enter a valid Email address.
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 p-0 pr-md-3">
          <div class="form-group">
            <label for="password"
              >Password <span class="text-danger">*</span></label
            >
            <input
              type="password"
              [ngClass]="{ 'form-control': true, 'has-value': !!pwd.value }"
              id="password"
              name="password"
              pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-]).{6,}$"
              minlength="8"
              maxlength="40"
              [(ngModel)]="user.password"
              #pwd="ngModel"
              required
              autocomplete="off"
              (ngModelChange)="confirmPassword()"
              (focus)="this.passwordMeter = true"
              (focusout)="this.passwordMeter = false"
            />
            <button
              type="button"
              *ngIf="!!pwd.value"
              class="right-icon toggle-password"
              appPasswordVisibilityToggle
              toggle="#password"
            >
              <app-icon name="eye"></app-icon>
            </button>
            <div class="invalid-feedback" *ngIf="f.submitted && pwd.invalid">
              <span *ngIf="pwd.errors?.['required']"
                >Please Enter the Password.</span
              >
              <span *ngIf="pwd.errors?.['minlength']">
                Password must be at least 8 characters long.</span
              >
              <span *ngIf="pwd.errors?.['maxlength']">
                Password is limited upto 40 characters.</span
              >
              <span *ngIf="pwd.errors?.['pattern']"
                >Please enter valid pasword,it must contain at least one capital
                and one lower-case letter (Aa-Zz), one special symbol (#, &, %
                etc), and one number (0-9) in your password for the best
                strength.</span
              >
            </div>
          </div>
          <password-strength-meter
            *ngIf="this.passwordMeter"
            class="font-16"
            type="password-strength-meter"
            name="passMeter"
            id="passMeter"
            [colors]="['darkred', 'orangered', 'orange', 'yellowgreen']"
            [minPasswordLength]="8"
            [enableFeedback]="true"
            [password]="pwd.value"
          ></password-strength-meter>
        </div>
        <div class="col-md-12 p-0 pr-md-3">
          <div class="form-group">
            <label for="passwordConf"
              >Confirm Password <span class="text-danger">*</span></label
            >
            <input
              type="password"
              [ngClass]="{ 'form-control': true, 'has-value': !!pwdconf.value }"
              id="passwordConf"
              name="passwordConf"
              [(ngModel)]="user.passwordconf"
              (focusout)="confirmPassword()"
              #pwdconf="ngModel"
              (ngModelChange)="confirmPassword()"
              (ngModelChange)="confirmPassword()"
              required
              autocomplete="off"
            />
            <button
              type="button"
              *ngIf="!!pwdconf.value"
              class="right-icon toggle-password"
              appPasswordVisibilityToggle
              toggle="#passwordConf"
            >
              <app-icon name="eye"></app-icon>
            </button>
            <div
              class="invalid-feedback"
              *ngIf="f.submitted && pwdconf.invalid"
            >
              <span *ngIf="pwdconf.errors?.['required']"
                >Please Re-enter the password.</span
              >
            </div>
            <div class="invalid-feedback" *ngIf="match == false && f.submitted">
              Password and Confirm Password does not match.
            </div>
          </div>
        </div>
        <!-- .col -->
        <!-- <div class="col-12 px-0">
          <p class="fw-500 mt-2"><span class="fw-600 text-danger">Important:</span> Missing or incorrect info may cause verification to fail.
          You can update your display name after verification—as long as it matches part of your ID.</p>
        </div> -->
        <div class="col-12 px-0 pr-md-3 phone-number-field">
          <div class="form-group signup-phone-form-group">
            <label for="phoneNumberSignup">Phone Number</label>
            <input
              type="text"
              mask="(000) 000-0000"
              inputmode="tel"
              autocomplete="tel"
              class="form-control signup-phone-input"
              [class.has-value]="!!phoneNumber"
              [class.is-invalid]="phoneExist"
              id="phoneNumberSignup"
              name="phoneNumber"
              [(ngModel)]="phoneNumber"
              (ngModelChange)="phoneExist = false"
            />

            <div class="country-code-dropdown signup-phone-country">
              <button
                class="btn signup-country-code-button"
                type="button"
                (click)="toggleCountryDropdown($event)"
                [attr.aria-label]="
                  'Select country code, ' +
                  (selectedCountry?.callingCode || '+1')
                "
              >
                <img
                  *ngIf="selectedCountry?.flagUrl"
                  [src]="selectedCountry.flagUrl"
                  class="country-flag-img"
                  alt=""
                  aria-hidden="true"
                />
                <img
                  *ngIf="!selectedCountry?.flagUrl"
                  src="assets/images/flag_placeholder.png"
                  class="country-flag-img"
                  alt=""
                  aria-hidden="true"
                />
                <span>{{ selectedCountry?.callingCode || '+1' }}</span>
                <app-icon
                  name="chevron-down"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
              </button>
              <div class="country-dropdown-menu" *ngIf="countryDropdownOpen">
                <div class="country-search-wrap cx-search-control px-2 pb-1">
                  <app-icon
                    name="search"
                    class="cx-search-control__icon"
                    aria-hidden="true"
                  ></app-icon>
                  <input
                    #countrySearchInput_signup
                    type="search"
                    class="form-control country-search-input cx-search-control__input"
                    placeholder="Search country..."
                    [(ngModel)]="countrySearchTerm"
                    (input)="filterCountries()"
                    name="countrySearchSignup"
                    autocomplete="off"
                    (click)="$event.stopPropagation()"
                  />
                  <button
                    *ngIf="countrySearchTerm"
                    type="button"
                    class="cx-search-control__clear"
                    (click)="
                      countrySearchTerm = '';
                      filterCountries();
                      $event.stopPropagation()
                    "
                    aria-label="Clear country search"
                  >
                    <app-icon name="x" aria-hidden="true"></app-icon>
                  </button>
                </div>
                <div class="country-list">
                  <a
                    class="dropdown-item country-item"
                    *ngFor="let country of filteredCountries"
                    (click)="selectCountry(country)"
                  >
                    <img
                      [src]="country.flagUrl"
                      class="country-flag-img"
                      alt=""
                    />
                    <span class="country-name">{{ country.name }}</span>
                    <span class="country-code ml-auto">{{
                      country.callingCode
                    }}</span>
                  </a>
                </div>
              </div>
            </div>

            <div *ngIf="phoneExist" class="invalid-feedback d-block">
              This phone number is already verified. Please use a different
              number.
            </div>
          </div>
        </div>
        <!-- <div class="col-12 px-0">
          <div class="form-group">
            <div class="custom-control custom-checkbox consent-checkbox">
              <input type="checkbox" class="custom-control-input" name="smsCheckbox" id="smsCheckbox"/>
              <label for="smsCheckbox" class="custom-control-label pl-xl-0 pl-lg-1 pl-sm-2 mt-0"> I consent to receive SMS verification codes from 
                CitizeX. I understand that consent is not required to use the platform and I can opt out at any time. Message and data rates may apply.
              </label>
            </div>
          </div>
        </div> -->
        <div class="col-12 px-0">
          <div class="form-group">
            <div class="checkbox consent-checkbox">
              <input
                type="checkbox"
                id="terms-and-condition"
                name="terms-and-condition"
                ngModel
                #terms="ngModel"
                tabindex="6"
                [(ngModel)]="termsAndConditionFlag"
                required
              />
              <label for="terms-and-condition" class="checkbox-label mt-0"
                ><span
                  >I agree with
                  <a
                    class="p-0"
                    routerLink="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b>Terms &amp; Conditions,</b></a
                  >
                  <a
                    class="p-0"
                    routerLink="/privacy-and-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><b>&nbsp;Privacy Policy</b>
                  </a>
                  and
                  <a
                    class="p-0"
                    routerLink="/child-safety-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><b>Child Safety Policy.</b>
                  </a>
                  <span class="text-danger" aria-hidden="true"> *</span></span
                >
              </label>
            </div>
            <!-- <div class="col-12 text-center mt-4 mb-3">
                By signing up, you agree
                <a class="btn-link btn-underline btn-link-font fw-700" routerLink="/terms-and-conditions">
                  Terms and conditions
                </a>
                and 
                <a routerLink="/privacy-and-policy" class="btn-link btn-underline btn-link-font fw-700">
                  Privacy Policy
                </a>
    
              </div> -->
            <div
              class="invalid-feedback checkbox-error-msg"
              *ngIf="f.submitted && terms.invalid"
            >
              <span *ngIf="terms.errors?.['required']"
                >Sorry, you must accept terms and conditions and Privacy
                Policy.</span
              >
            </div>
          </div>
        </div>
        <div class="col-12 px-0">
          <div class="form-group">
            <div class="checkbox consent-checkbox">
              <input
                type="checkbox"
                id="share-contact-with-event-hosts"
                name="shareContactWithEventHosts"
                [(ngModel)]="shareContactWithEventHosts"
              />
              <label
                for="share-contact-with-event-hosts"
                class="checkbox-label mt-0"
              >
                <span>
                  Share my email address and phone number with hosts of events I
                  RSVP to or attend so they can contact me about those events.
                  This is optional, and I can change it at any time in Account
                  settings.
                </span>
                <!-- By verifying and checking this box, you consent
                to your contact information being provided to the host of any virtual events that you attend which they
                may use for their own outreach.
                <br />
                <span class="mt-1">
                  By unclicking this box, your contact information will remain private and will not be shared with
                  hosts.
                  If a phone number is provided, it may be used for account security and verification purposes. Message
                  and data rates may apply.
                </p> -->
              </label>
            </div>
          </div>
        </div>
        <!-- .col -->

        <div class="col-md-12 pt-md-3 pt-4 p-0 pr-md-3 text-center">
          <button
            type="submit"
            class="btn btn-black w-100"
            [disabled]="f.invalid || loading"
            (click)="signUp(f.invalid)"
          >
            <span *ngIf="!loading">Next</span>
            <span *ngIf="loading" class="d-inline-flex align-items-center">
              <span
                class="citizex-spinner citizex-spinner--sm mr-2"
                aria-hidden="true"
              ></span>
              Processing...
            </span>
          </button>
          <p class="font-14 font-gray mt-3">
            Already have an account ?
            <a
              [routerLink]="['/login']"
              class="btn btn-link btn-link-theme font-14 p-0"
            >
              &nbsp;Sign In
            </a>
          </p>
        </div>
        <div class="col-12 text-center p-0 pr-md-3 mt-2">
          <a
            class="btn btn-link btn-link-theme font-14 p-0"
            [routerLink]="['/trouble-signing-up']"
          >
            Trouble signing up?
          </a>
        </div>

        <!-- .col -->
      </form>
    </div>
    <!-- .col-md-12 -->
  </div>
  <!-- .row step==1 -->
  <!-- Signup step == 1  Ends-->

  <!-- Signup step == 2 -->
  <div class="row m-0 py-2 center" *ngIf="step == 2">
    <div
      class="col-12 col-sm-8 col-md-9 col-lg-7 offset-sm-2 offset-md-1 pl-sm-0"
    >
      <h2 class="text-center text-md-left title">Sign Up</h2>
      <p class="text-center text-md-left py-1 sub-title">
        Activate your account
      </p>
      <h6 class="text-center text-md-left sub-title pt-4 pb-2">
        We've sent an activation code to your email.<br />
        Please enter that code below.
      </h6>
      <form
        class="row m-0 square-form needs-validation cx-standard-form"
        (ngSubmit)="(f.form.valid)"
        #f="ngForm"
        novalidate
        autocomplete="off"
      >
        <div
          *ngIf="activationsent == true"
          class="col-md-12 my-2 alert alert-info"
        >
          Activation Code sent again.
          <button
            type="button"
            (click)="activationsent = false"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <div class="col-12 activation-grid form-group">
          <div
            [ngClass]="{
              'is-invalid':
                incorrectActCode == true ||
                (f.submitted && (f.untouched || f.invalid))
            }"
            *ngFor="
              let item of actCodeArr;
              let index = index;
              trackBy: trackByIndex
            "
          >
            <div class="input-field my-0">
              <input
                type="text"
                tabindex="{{ index + 1 }}"
                id="activationCode{{ index }}"
                name="actCodee[index]"
                class="form-control text-center activation-field h-2"
                maxlength="1"
                required
                #act="ngModel"
                (input)="keytab(this.index, $event, 'input')"
                (keyup)="keytab(this.index, $event, 'keyup')"
                (focus)="onFocus($event)"
                (paste)="onPestCode($event, 'activationCode', 6)"
                [(ngModel)]="actCodeArr[index]"
                inputmode="tel"
              />
            </div>
          </div>
          <div class="text-center invalid-feedback">
            <span *ngIf="f.submitted && (f.untouched || f.invalid)">
              Please Enter Activation Code.
            </span>
            <span *ngIf="incorrectActCode == true">
              Invalid Activation Code.
            </span>
          </div>
        </div>
        <!-- .col -->

        <div class="col-md-12 pt-md-3 pt-4 text-center">
          <div class="row">
            <div class="col-6 pr-1 text-left">
              <input
                type="button"
                (click)="previous()"
                class="btn btn-underline mt-2 px-0"
                value="Back"
                tabindex="7"
              />
            </div>
            <div class="col-6 pr-1">
              <input
                type="submit"
                (click)="activationCodeVerify(f.invalid)"
                class="btn btn-black mt-2 w-100"
                value="Next"
                tabindex="7"
              />
            </div>
          </div>
          <p class="font-14 font-gray mt-3">
            Didn't get activation code ?
            <a
              (click)="resendActivationCode(f)"
              class="btn btn-link btn-link-theme font-14 p-0"
              tabindex="8"
            >
              &nbsp;Resend now
            </a>
          </p>
          <p class="font-14 font-gray mt-2">
            Already have an account ?
            <a
              [routerLink]="['/login']"
              class="btn btn-link btn-link-theme font-14 p-0"
              tabindex="9"
            >
              &nbsp;Sign In
            </a>
          </p>
        </div>
        <!-- .col -->
      </form>
    </div>
    <!-- .col-md-12 -->
  </div>
  <!-- .row step==2 -->
  <!-- Signup step==2 Ends-->

  <!-- Signup step == 3 -->
  <div class="row m-0 py-2 center" *ngIf="step == 3">
    <div class="col-md-9 col-sm-9 offset-md-1 offset-sm-2 pl-sm-0">
      <!-- <h1 class="text-md-left text-center">Verify your Identity</h1> -->
      <!-- <div class="mt-3 p-3 bg-very-light-warning" *ngIf="[7, 15, 30].includes(diffDate)"> -->
      <!-- <div class="mt-3 p-3 bg-very-light-warning" *ngIf="this.user.verified == false">
        CitizeX believes the best way to get honest feedback and information is by it having the person posting it
        identify themselves. Therefore, not only does CitizeX restrict anonymous users to post, but it links it every
        feedback and comment to the user making it. Therefore, you must have your identity verified using the following
        steps below in order to be eligible to contribute to CitizeX.
      </div> -->
      <p
        class="py-2 text-md-left text-center"
        data-testid="verification-guidance"
      >
        Verify your phone number and ID to post, reply, and join verified-only
        events. You can keep browsing and resume verification later from your
        account menu.
      </p>
      <p *ngIf="fullyVerified" class="alert alert-warning" role="status">
        Verification is not complete yet. Check the tasks below for the next
        step.
      </p>
      <form class="row m-0 cx-standard-form" #f="ngForm" novalidate>
        <ol class="col-12 list-unstyled px-0" aria-label="Account setup tasks">
          <li class="mb-3">
            <button
              type="button"
              class="verification-option"
              (click)="openTextVerificationModal(f)"
              [disabled]="accountStatus.phoneVerification === 'complete'"
            >
              <app-icon
                name="circle"
                class="verification-option-control"
                aria-hidden="true"
              ></app-icon>
              <app-icon
                name="message-square-text"
                class="verification-option-service-icon"
                aria-hidden="true"
              ></app-icon>
              <span class="verification-option-label">Phone verification</span>
              <span
                class="col-auto verified"
                *ngIf="accountStatus.phoneVerification === 'complete'"
                >Complete</span
              >
              <span
                class="col-auto"
                *ngIf="accountStatus.phoneVerification !== 'complete'"
                >Start phone verification</span
              >
            </button>
          </li>
          <li class="mb-3">
            <button
              type="button"
              class="verification-option"
              (click)="openVerificationModal()"
              [disabled]="
                accountStatus.idVerification === 'complete' ||
                accountStatus.idVerification === 'pending'
              "
            >
              <app-icon
                name="circle"
                class="verification-option-control"
                aria-hidden="true"
              ></app-icon>
              <app-icon
                name="badge-check"
                class="verification-option-service-icon"
                aria-hidden="true"
              ></app-icon>
              <span class="verification-option-label">ID verification</span>
              <span
                class="col-auto verified"
                *ngIf="accountStatus.idVerification === 'complete'"
                >Complete</span
              >
              <span
                class="col-auto"
                *ngIf="accountStatus.idVerification === 'pending'"
                >Under review</span
              >
              <span
                class="col-auto"
                *ngIf="accountStatus.idVerification === 'in-progress'"
                >Start a new ID check</span
              >
              <span
                class="col-auto"
                *ngIf="
                  accountStatus.idVerification === 'failed' &&
                  idStatusKey !== 'approved'
                "
                >Try ID verification again</span
              >
              <span
                class="col-auto"
                *ngIf="
                  accountStatus.idVerification === 'failed' &&
                  idStatusKey === 'approved'
                "
                >Check ID status</span
              >
              <span
                class="col-auto"
                *ngIf="accountStatus.idVerification === 'not-started'"
                >Start ID verification</span
              >
            </button>
            <div
              class="verification-warning"
              *ngIf="accountStatus.idVerification === 'in-progress'"
              role="note"
              data-testid="id-session-warning"
            >
              <app-icon
                name="circle-alert"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon>
              <p>
                Your previous ID session has not finished. If you closed it,
                start a new check. This replaces the previous session.
              </p>
            </div>
            <p class="mt-2" *ngIf="accountStatus.idVerification === 'pending'">
              Your ID check is under review. Check again soon; you can continue
              browsing while you wait.
            </p>
            <p
              class="mt-2"
              *ngIf="
                idStatusKey === 'rejection' &&
                accountStatus.idVerification === 'failed'
              "
            >
              We could not confirm your identity. Make sure your account details
              match your ID. You can
              <a routerLink="/edit-user">edit your details</a> before retrying.
            </p>
            <p
              class="mt-2"
              *ngIf="
                idStatusKey === 'declined' &&
                accountStatus.idVerification === 'failed'
              "
            >
              Your ID check was declined. You can try a new check. If your
              account details need correcting,
              <a routerLink="/edit-user">edit your details</a> first.
            </p>
            <p
              class="mt-2"
              *ngIf="
                idStatusKey === 'abandoned' &&
                accountStatus.idVerification === 'failed'
              "
            >
              Your ID check ended before it was submitted. Start a new check
              when you are ready.
            </p>
            <p
              class="mt-2"
              *ngIf="
                (idStatusKey === 'expired' || idStatusKey === 'kyc expired') &&
                accountStatus.idVerification === 'failed'
              "
            >
              Your ID session expired. Start a new check when you are ready.
            </p>
            <p
              class="mt-2"
              *ngIf="
                idStatusKey === 'approved' &&
                accountStatus.idVerification === 'failed'
              "
            >
              Your ID result is approved, but your account has not updated.
              Check the status again; if it still is not complete, contact
              support.
            </p>
            <p class="mt-2 text-danger" *ngIf="diditErrMsg">
              {{ diditErrMsg }}
            </p>
          </li>
        </ol>
        <div
          class="col-12 px-0 d-flex flex-wrap align-items-center justify-content-end"
        >
          <button
            *ngIf="canRefreshVerificationStatus"
            type="button"
            class="btn btn-outline-black mr-auto mb-2"
            (click)="getUserDetails(true)"
            [disabled]="verificationStatusRefreshing"
            [attr.aria-busy]="verificationStatusRefreshing"
            [attr.aria-describedby]="
              verificationStatusMessage ? 'verification-status-message' : null
            "
          >
            {{
              verificationStatusRefreshing
                ? 'Checking…'
                : 'Check verification status'
            }}
          </button>
          <button
            type="button"
            class="btn btn-outline-black mb-2 ml-auto"
            data-testid="continue-browsing"
            (click)="continueBrowsing()"
          >
            Continue browsing
          </button>
        </div>
        <p
          *ngIf="verificationStatusMessage"
          id="verification-status-message"
          class="col-12 px-0 mt-1 mb-0"
          [class.text-danger]="verificationStatusError"
          role="status"
          aria-live="polite"
        >
          {{ verificationStatusMessage }}
        </p>
      </form>
    </div>
    <!-- .col-md-8 -->
  </div>
  <!-- .row step==3 -->
  <!-- Signup step==3 Ends-->

  <!-- Signup step == 4 -->
  <div class="row m-0 py-2 center" *ngIf="step == 4">
    <div
      class="col-12 col-sm-8 col-md-9 col-lg-7 offset-sm-2 offset-md-1 pl-sm-0"
    >
      <h2 class="text-center text-md-left title">Sign Up</h2>
      <!-- <p class="text-center text-md-left py-1 sub-title">You will need Username and Password</p> -->
      <p class="text-center text-md-left py-1 sub-title">
        All new passwords must contain at least 8 characters. There must be at
        least one capital and one lower-case letter (Aa-Zz), one special symbol
        (#, &, % etc), and one number (0-9) in your password for the best
        strength.
      </p>
      <form
        class="row m-0 square-form needs-validation cx-standard-form"
        (ngSubmit)="(f.form.valid)"
        #f="ngForm"
        novalidate
      >
        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="f.submitted && (f.untouched || f.invalid)"
        >
          Please fill up all the details correctly.
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <div
          class="col-md-12 my-2 alert alert-danger"
          *ngIf="match == false && !(f.untouched || f.invalid)"
        >
          Password and Confirm Password does not match.
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><app-icon
                name="x"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon
            ></span>
          </button>
        </div>
        <!-- .alert-dangers -->

        <!-- <div class="col-md-12 px-0">
          <div class="form-group">
            <input
              type="text"
              [ngClass]="{ 'form-control': true, 'has-value': !!uname.value }"
              id="userName"
              name="username"
              pattern="^[A-Za-z0-9_\/.\-]+$"
              #uname="ngModel"
              [(ngModel)]="user.userName"
              (focusout)="checkExistingUsername()"
              tabindex="1"
              required
            />
            <label for="input" class="control-label">Username</label>
            <div class="invalid-feedback" *ngIf="f.submitted && uname.invalid">
              <span *ngIf="uname.errors.required"> Please Enter Username.</span>
              <span *ngIf="uname.errors.pattern"> Please enter a valid Username. Username should be alphanumeric and it does not contain spaces. </span>
            </div>
            <div class="invalid-feedback" *ngIf="userExists == true">
              <span> Username already exists, please try a different username. </span>
            </div>
          </div>
        </div> -->
        <!-- .col -->

        <div class="col-md-12 p-0">
          <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              [ngClass]="{ 'form-control': true, 'has-value': !!pwd.value }"
              id="password"
              name="password"
              pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-]).{6,}$"
              minlength="8"
              maxlength="40"
              [(ngModel)]="user.password"
              #pwd="ngModel"
              required
              autocomplete="off"
              (focus)="this.passwordMeter = true"
              (focusout)="this.passwordMeter = false"
            />
            <button
              type="button"
              *ngIf="!!pwd.value"
              class="right-icon toggle-password"
              appPasswordVisibilityToggle
              toggle="#password"
            >
              <app-icon name="eye"></app-icon>
            </button>
            <div class="invalid-feedback" *ngIf="f.submitted && pwd.invalid">
              <span *ngIf="pwd.errors?.['required']"
                >Please Enter the Password.</span
              >
              <span *ngIf="pwd.errors?.['minlength']">
                Password must be at least 8 characters long.</span
              >
              <span *ngIf="pwd.errors?.['maxlength']">
                Password is limited upto 40 characters.</span
              >
              <span *ngIf="pwd.errors?.['pattern']"
                >Please enter valid pasword,it must contain at least one capital
                and one lower-case letter (Aa-Zz), one special symbol (#, &, %
                etc), and one number (0-9) in your password for the best
                strength.</span
              >
            </div>
          </div>
          <password-strength-meter
            *ngIf="this.passwordMeter"
            class="font-16"
            type="password-strength-meter"
            name="passMeter"
            id="passMeter"
            [colors]="['darkred', 'orangered', 'orange', 'yellowgreen']"
            [minPasswordLength]="8"
            [enableFeedback]="true"
            [password]="pwd.value"
          ></password-strength-meter>
        </div>
        <!-- .col -->

        <div class="col-md-12 p-0">
          <div class="form-group">
            <label for="passwordConf">Confirm Password</label>
            <input
              type="password"
              [ngClass]="{ 'form-control': true, 'has-value': !!pwdconf.value }"
              id="passwordConf"
              name="passwordConf"
              [(ngModel)]="user.passwordconf"
              (focusout)="confirmPassword()"
              #pwdconf="ngModel"
              required
              autocomplete="off"
            />
            <button
              type="button"
              *ngIf="!!pwdconf.value"
              class="right-icon toggle-password"
              appPasswordVisibilityToggle
              toggle="#passwordConf"
            >
              <app-icon name="eye"></app-icon>
            </button>
            <div
              class="invalid-feedback"
              *ngIf="f.submitted && pwdconf.invalid"
            >
              <span *ngIf="pwdconf.errors?.['required']"
                >Please Re-enter the password.</span
              >
            </div>
          </div>
        </div>
        <!-- .col -->

        <div class="col-md-12 pt-4 text-center px-0">
          <div class="row">
            <div class="col-6 pr-1 text-left">
              <input
                type="button"
                (click)="previous()"
                class="btn btn-underline px-0"
                value="Back"
              />
            </div>
            <div class="col-6 pl-1">
              <input
                type="submit"
                class="btn btn-black w-100"
                (click)="activateProfile(f.invalid)"
                value="Sign Up"
              />
            </div>
          </div>
          <h6 class="mt-3">
            Already have an account ?
            <a
              [routerLink]="['/login']"
              class="btn btn-link btn-link-theme font-14 p-0"
              >&nbsp;Sign In</a
            >
          </h6>
        </div>
        <!-- .col -->
      </form>
    </div>
    <!-- .col-md-8 -->
  </div>
  <!-- .row step==4 -->
  <!-- Signup step==4 Ends-->
  <div class="row m-0 py-2" *ngIf="step == 5">
    <div
      class="col-12 col-sm-8 col-md-9 col-lg-7 offset-sm-2 offset-md-1 signup-id-form px-0"
    >
      <div class="col-12 px-0">
        <p class="display-name-guidance" data-testid="display-name-guidance">
          We’ve filled in your name from your ID. Adjust the display name below
          if needed—it must match part of your ID.
        </p>
      </div>
      <div class="col-sm-10 col-12 pl-0">
        <form class="mt-4 square-form cx-standard-form">
          <div class="col-12 pl-0">
            <div
              class="col-md-12 my-2 alert alert-danger"
              *ngIf="errorMessage != ''"
            >
              {{ errorMessage }}
              <button
                type="button"
                data-dismiss="alert"
                aria-label="Close"
                class="close"
              >
                <span
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
          </div>
          <div class="col-12 d-flex px-0" *ngIf="user?.name?.prefix">
            <div class="col-sm-7 pl-0">
              <label class="fw-600 text-left">Prefix</label>
              <input
                type="text"
                class="form-control custom-input"
                [value]="getNamePart('prefix')"
                disabled
              />
            </div>
            <div
              class="col-sm-5 pl-0 d-flex align-items-end select-input-padding"
            >
              <select
                class="form-control select-input"
                [(ngModel)]="user.nameDisplayPreferenceDTO.prefix"
                (change)="generatePreview()"
                name="user.nameDisplayPreferenceDTO.prefix"
              >
                <option value="full">Full</option>
                <option value="hide">Hide</option>
              </select>
            </div>
          </div>
          <div class="col-12 d-flex mt-3 px-0">
            <div class="col-sm-7 pl-0">
              <label class="fw-600 text-left">First</label>
              <input
                type="text"
                class="form-control custom-input"
                [value]="getNamePart('firstName')"
                (input)="onFirstNameInput($event)"
                [disabled]="
                  user.nameDisplayPreferenceDTO.firstName !== 'custom'
                "
              />
            </div>
            <div
              class="col-sm-5 pl-0 d-flex align-items-end select-input-padding"
            >
              <select
                class="form-control select-input"
                [(ngModel)]="user.nameDisplayPreferenceDTO.firstName"
                (change)="generatePreview()"
                [disabled]="user.nameDisplayPreferenceDTO.keepAsIs"
                name="firstNamePref"
              >
                <option value="full">Full</option>
                <option value="initial">Initial</option>
                <option value="hide" *ngIf="user.name.middleName">Hide</option>
                <option value="custom">Custom</option>
              </select>
            </div>
          </div>
          <div class="col-12 d-flex mt-3 px-0" *ngIf="user?.name?.middleName">
            <div class="col-sm-7 pl-0">
              <label class="fw-600 text-left">Middle</label>
              <input
                type="text"
                class="form-control custom-input"
                [value]="getNamePart('middleName')"
                (input)="onMiddleNameInput($event)"
                [disabled]="
                  user.nameDisplayPreferenceDTO.middleName !== 'custom'
                "
              />
            </div>
            <div
              class="col-sm-5 pl-0 d-flex align-items-end select-input-padding"
            >
              <select
                class="form-control select-input"
                [(ngModel)]="user.nameDisplayPreferenceDTO.middleName"
                (change)="generatePreview()"
                [disabled]="user.nameDisplayPreferenceDTO.keepAsIs"
                name="middleNamePref"
              >
                <option value="full">Full</option>
                <option value="initial">Initial</option>
                <option value="hide">Hide</option>
                <option value="custom">Custom</option>
              </select>
            </div>
          </div>
          <div class="col-12 d-flex mt-3 px-0">
            <div class="col-sm-7 pl-0">
              <label class="fw-600 text-left">Last</label>
              <input
                type="text"
                class="form-control custom-input"
                [value]="getNamePart('lastName')"
                (input)="onLastNameInput($event)"
                [disabled]="user.nameDisplayPreferenceDTO.lastName !== 'custom'"
              />
            </div>
            <div
              class="col-sm-5 pl-0 d-flex align-items-end select-input-padding"
            >
              <select
                class="form-control select-input"
                [(ngModel)]="user.nameDisplayPreferenceDTO.lastName"
                (change)="generatePreview()"
                [disabled]="user.nameDisplayPreferenceDTO.keepAsIs"
                name="lastNamePref"
              >
                <option value="full">Full</option>
                <option value="initial">Initial</option>
                <option value="hide" *ngIf="user.name.middleName">Hide</option>
                <option value="custom">Custom</option>
              </select>
            </div>
          </div>
          <div class="col-12 d-flex mt-3 px-0" *ngIf="user?.name?.suffix">
            <div class="col-sm-7 pl-0">
              <label class="fw-600 text-left">Suffix</label>
              <input
                type="text"
                class="form-control custom-input"
                [value]="getNamePart('suffix')"
                disabled
              />
            </div>
            <div
              class="col-sm-5 pl-0 d-flex align-items-end select-input-padding"
            >
              <select
                class="form-control select-input"
                [(ngModel)]="user.nameDisplayPreferenceDTO.suffix"
                (change)="generatePreview()"
                name="user.nameDisplayPreferenceDTO.suffix"
              >
                <option value="full">Full</option>
                <option value="hide">Hide</option>
              </select>
            </div>
          </div>
          <div class="form-group mt-0 col-12 mt-4 px-0">
            <div class="checkbox">
              <input
                class="form-check-input"
                type="checkbox"
                id="keepIt"
                name="keepIt"
                [(ngModel)]="user.nameDisplayPreferenceDTO.keepAsIs"
                (change)="onKeepAsIsChange($event)"
              />
              <label for="keepIt" class="checkbox-label font-16 fw-600"
                >Keep it as it is</label
              >
            </div>
          </div>
          <div class="col-sm-7 mt-3 px-0">
            <div class="preview-msg">
              <strong>Preview:</strong> {{ previewName }}
            </div>
          </div>
          <div class="col-12 mt-4 text-center px-0">
            <button
              type="button"
              class="btn btn-black"
              [disabled]="disable"
              (click)="updateUser()"
            >
              Save and find your page
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- .content -->
<!-- signup Ends -->

<!-- <div id="termAndCondition" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="termAndConditionTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-custom modal-dialog-scrollable modal-theme modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-3">
        <h4 class="modal-title" id="termAndConditionTitle">Terms and Conditions</h4>
      </div>
      <div class="modal-body mxh-80vh overflow-auto">
        <br />

        <h6 class="bold text-center"><u>END USER LICENSE AGREEMENT</u></h6>

        <p class="mt-3 ml-3 mr-3 text-justify">
          The following END USER LICENSE AGREEMENT (the “EULA”) governs the use of Jikia (“we,” “our,” or “us”) websites, located at www.citizex.info, or participating in any online features, services and/or programs oﬀered by us
          (collectively, the “Website”). This EULA is in eﬀect for all of our Websites.
        </p>

        <p class="mt-3 bold ml-5 mr-5 text-justify">
          BY ACCESSING OR USING OUR WEBSITES, YOU ARE ENTERING INTO A LEGAL CONTRACT WITH JIKIA REGARDING YOUR USE OF THE WEBSITES AND YOU AGREE TO BE BOUND BY THIS EULA. IF YOU DO NOT AGREE TO ANY PORTION OF THIS EULA, YOU SHOULD NOT
          ACCESS OR OTHERWISE USE THE WEBSITE.
        </p>

        <p class="mt-3 bold ml-5 mr-5 text-justify">
          YOU SHOULD CAREFULLY REVIEW THIS ENTIRE EULA. INCLUDED IN THIS LEGAL CONTRACT ARE (i) REQUIREMENTS THAT YOU PROVIDE TRUTHFUL, ACCURATE, CURRENT AND COMPLETE INFORMATION ABOUT YOUR IDENTITY; (ii) PROHIBITIONS ON ALLOWING ANYONE OR
          ANY ENTITY OTHER THAN YOURSELF USE OF YOUR USER ACCOUNT; AND (iii) TERMS CLEARLY INDICATING YOU ARE RESPONSIBLE FOR ANY LEGAL ISSUES CAUSED BY YOUR CONTENT OR YOUR USE OF THE WEBSITES.
        </p>

        <h6 class="mt-4 text-center mb-4 bold"><u>TABLE OF CONTENTS</u></h6>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">1.</div>
          <div class="col px-0">CONVENIENCE AND INFORMATION ONLY</div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">2.</div>
          <div class="col px-0">USER ACCOUNT</div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">3.</div>
          <div class="col px-0">ACCURATE AND TRUTHFUL INFORMATION</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">4.</div>
          <div class="col px-0">ACCOUNT DEACTIVATION</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">5.</div>
          <div class="col px-0">OBJECTIONABLE MATERIAL</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">6.</div>
          <div class="col px-0">CONTENT</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">7.</div>
          <div class="col px-0">OUR PARTICIPATION</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">8.</div>
          <div class="col px-0">NO WARRANTIES, LIMITATIONS OF LIABILITY, YOUR INDEMNIFICATION OF US</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">9.</div>
          <div class="col px-0">JURISDICTION AND VENUE</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2">
          <div class="col-auto pl-0 pr-2">10.</div>
          <div class="col px-0">MISCELLANEOUS</div>
        </div>

        <div class="row mx-0 mt-5 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>1.</b></div>
          <div class="col px-0">
            <b>CONVENIENCE AND INFORMATION ONLY.</b> The Websites are provided to you as a convenience and for your informaKon only. By merely providing access to the Website, we do <b><u>NOT</u></b> guarantee, warrant or represent that:
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">
            Any materials, statements, reviews, ratings, opinions, documents, images, graphics, logos, designs, audio, video, comments and any other information provided from or on the Websites (collectively, the “Content”) is accurate or
            complete;
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">The Content is up-to-date or current;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">We have any obligaKon to update any Content;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">d.</div>
          <div class="col px-0">We will keep your Content confidential or restrict third parties from any use of your Content;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">e.</div>
          <div class="col px-0">
            Any use, copy, reproduction, adaptation, publication, performance, or audio recording of the Content is free from allegations, claims, or lawsuits, including those based on allegations of intellectual property infringement,
            libel or slanderous defamatory statements, and/or violations of the right of publicity, including personality rights, the use of one's identity, such as name, image, likeness, or other unequivocal identifiers;
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">f.</div>
          <div class="col px-0">The Content is free from changes caused by a third party;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">g.</div>
          <div class="col px-0">g. Your access to the Website will be free from interruptions, errors, viruses or other harmful components;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">h.</div>
          <div class="col px-0">No data breach will ever occur; and/or</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">i.</div>
          <div class="col px-0">Information transmitted through the Internet is secure, or that such transmissions are free from delay, interruption, interception or error.</div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>2.</b></div>
          <div class="col px-0">
            <b>USER ACCOUNT.</b> To access the Website, we require you to select a username and password, and create a user account (“User Account”). User Accounts are unique to an individual real person. You are prohibited from creating or
            using a User Account on behalf of an entity, organization, group, non-profit, university or other educational institution, political organization, government or governmental agency or entity, etc. In your User Account
            information, you may designate or be required to designate affiliation with a such group; provided however, that use of your User Account is limited to you as an individual. The following shall apply to your User Account:
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">
            We use reasonable precautions to protect the privacy of your username, password, and User Account information including your User Identity (defined in §3a below). You, however, are ultimately responsible for protecting your
            username, password, and User Account information from disclosure to third parties;
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">You are not permitted to circumvent the use of required encryption technologies, if any;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">
            You agree to (i) immediately notify us of any unauthorized use of your username, password, or User Account, or any other breach of security, and (ii) ensure that you exit from your User Account at the end of each session;
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">d.</div>
          <div class="col px-0">
            Usernames and passwords are non-transferable, and all users are obligated to take preventative measures to prohibit any other person or entity from accessing the Websites with his or her username, password, or other account
            information
          </div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>3.</b></div>
          <div class="col px-0"><b> ACCURATE AND TRUTHFUL INFORMATION.</b> In creaKng and using your User Account for use on the Website, you agree to:</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">Provide true, accurate, current, and complete informaKon about yourself (“User IdenKty”); and</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">Maintain and promptly update your User IdenKty to keep it true, accurate, current, and complete.</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">
            You agree that we may collect and use data and related informaKon, including but not limited to demographical informaKon, poliKcal informaKon, technical informaKon about your device, system and applicaKon solware, and
            peripherals, and that we may use this informaKon, as long as it is in a form that does not personally idenKfy you.
          </div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>4.</b></div>
          <div class="col px-0">
            <b> ACCOUNT DEACTIVATION. </b>We reserve the right to, suspend, deacKvate, terminate or cancel your User Account, and/or remove some or all of any Content associated in any way with your User Account in our sole discreKon,
            including for the following reasons:
          </div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">You provide any informaKon that is untrue, inaccurate, not current, or incomplete, or if we have reasonable grounds to suspect that such informaKon is untrue, inaccurate, not current, or incomplete;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">You request such deacKvaKon;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">You are deceased;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">d.</div>
          <div class="col px-0">You do not respond to repeated communicaKon agempts;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">e.</div>
          <div class="col px-0">You reside in or relocate to a country where use of a User Account is prohibited under applicable law;</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">f.</div>
          <div class="col px-0">You allow any other person or enKty to access the Websites using your username and password, and/or</div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">g.</div>
          <div class="col px-0">You act in a fraudulent or an inappropriate manner while using the User Account.</div>
        </div>

        <div class="row mx-0 mt-5 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>5.</b></div>
          <div class="col px-0">
            <b>OBJECTIONABLE MATERIAL.</b> You acknowledge that in using the Websites and accessing the Content, you may encounter material that you may deem to be inaccurate, harmful, biased, disturbing, offensive or objecKonable. You
            agree to use the Websites at your sole risk and that we shall have no liability to you for any such material.
          </div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>6.</b></div>
          <div class="col px-0"><b> CONTENT</b></div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">
            TO PROTECT YOUR PRIVACY AND THE PRIVACY OF OTHERS, YOU WILL NOT PROVIDE ANY USER CONTENT THAT CONTAINS PERSONALLY IDENTIFIABLE INFORMATION (SUCH AS NAME, PHONE NUMBER, EMAIL OR MAILING ADDRESS, SOCIAL SECURITY NUMBER, ETC.)
            BELONGING TO ANYONE ELSE.
          </div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">UPLOADING IMAGES OR VIDEO OF OTHER PEOPLE WITHOUT THEIR EXPRESS WRITTEN PERMISSION IS STRICTLY PROHIBITED.</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">You are solely responsible for your Content, and the consequences of posKng or publishing it</div>
        </div>
        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">d.</div>
          <div class="col px-0">
            You represent and warrant that: (i) you own or have the necessary licenses, rights, consents, and permissions to use, and to authorize us and other users of the Websites to publish your Content; and (ii) to the extent
            applicable, you have the wrigen consent, release, and/or permission of each idenKfiable individual person in your Content to use the name or likeness of each such person to enable inclusion and publicaKon of the Content.
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">e.</div>
          <div class="col px-0">
            By providing Content to us, you hereby grant us a worldwide, non-exclusive, royalty-free, irrevocable, sublicenseable, and transferable license to use, reproduce, distribute, prepare derivaKve works of, display, publish,
            republish, and perform your Content, including, but not limited to, publicaKon of any porKon or all of your Content in an adverKsement, a book, a magazine, a spoken word work, any other literary work, and/or any other
            audio-visual work, in any medium or format, anywhere in the world.
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">f.</div>
          <div class="col px-0">You acknowledge that we reserve the right to pre-screen your Content and that we can in our sole discreKon refuse, move, and/or remove any Content for any reason.</div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">g.</div>
          <div class="col px-0">
            You agree to not use the Website to: (i) upload, post, email, transmit or otherwise make available any Content that is unlawful, harmful, threatening, abusive, harassing, bullying, torKous, false, defamatory, vulgar, obscene,
            pornographic, sexually explicit, libelous, invasive of another’s privacy, hateful, or racially, ethnically or otherwise objecKonable; (ii) harm minors in any way; (iii) impersonate any person or enKty, including, but not limited
            to, an official or an employee of Jikia; (iv) falsely state or otherwise misrepresent your affiliaKon with any person or enKty; (v) forge headers or otherwise manipulate idenKfiers in order to disguise the origin of any Content;
            (vi) upload, post, email, transmit, or otherwise make available any unsolicited or unauthorized adverKsing, promoKonal materials, spam, phishing schemes, pyramid schemes, or any other form of solicitaKon; (vii) upload, post,
            email, transmit, or otherwise make available any material that contains solware that may harm the operaKon of the Websites and their delivery of the Content to users; and/or (viii) intenKonally or unintenKonally violate any
            applicable local, state, naKonal, or internaKonal law; (ix) stalk or otherwise harass another; or (x) collect or store personal data about other users.
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">h.</div>
          <div class="col px-0">You acknowledge and agree that we may disclose your idenKty and/or User idenKty in connecKon with any claim of an intellectual property violaKon or any other courtordered purpose</div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>7.</b></div>
          <div class="col px-0">
            <b>OUR PARTICIPATION. </b>We do not endorse any Content, or any opinion, recommendaKon, or advice expressed in the Content, and we expressly disclaim any and all liability in connecKon with Content. We do not knowingly permit
            copyright infringing acKviKes and infringement of intellectual property rights on the Websites. We reserve the right to remove Content without prior noKce. Without limiKng our right to cause the terminaKon of a User Account for
            any or no reason, we will also cause the terminaKon of a User Account if a user is determined to be a repeat offender, a repeat offender being a user who has been noKfied of inappropriate Content or behavior.
          </div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>8.</b></div>
          <div class="col px-0"><b> NO WARRANTIES, LIMITATIONS OF LIABILITY, YOUR INDEMNIFICATION OF US.</b></div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">
            NO WARRANTIES FOR WEBSITES. We make no warranty concerning the delay, failure, interrupKon, or corrupKon of any data, the Content, or other informaKon transmiged in connecKon with the use of the Websites. YOU EXPRESSLY AGREE
            THAT YOUR USE OF THE WEBSITES IS AT YOUR SOLE RISK. THE WEBSITES, THE CONTENT IS PROVIDED “AS IS” AND “AS AVAILABLE” FOR YOUR USE, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, UNLESS SUCH WARRANTIES ARE LEGALLY
            INCAPABLE OF EXCLUSION. WE MAKE NO REPRESENTATIONS OR WARRANTIES THAT THE WEBSITES, THE CONTENT, OR ANY SERVICES OFFERED IN CONNECTION WITH THE WEBSITES, ARE OR WILL REMAIN UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
            CORRECTED, OR THAT THE WEB PAGES ON OR THROUGH THE WEBSITES, OR THE SERVERS USED IN CONNECTION WITH THE WEBSITES, ARE OR WILL REMAIN FREE FROM ANY VIRUSES, WORMS, TIME BOMBS, DROP DEAD DEVICES, TROJAN HORSES, OR OTHER HARMFUL
            COMPONENTS. WE DO NOT GUARANTEE THAT YOU WILL BE ABLE TO ACCESS OR USE THE WEBSITES AT TIMES OR LOCATIONS OF YOUR CHOOSING, OR THAT WE WILL HAVE ADEQUATE CAPACITY FOR THE WEBSITES AS A WHOLE OR IN ANY SPECIFIC GEOGRAPHIC AREA.
            WE MAKE NO REPRESENTATION OR WARRANTY REGARDING GOVERNMENT COMPLIANCE OF ANY SOFTWARE USED IN RUNNING THE WEBSITES. OUR ENTIRE LIABILITY AND YOUR EXCLUSIVE REMEDY WITH RESPECT TO THE USE OF ANY SERVICE OR PRODUCT PROVIDED ON OR
            THROUGH THE WEBSITES WILL BE THE REFUND OF MONIES PAID BY YOU TO US, IF ANY.
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">
            LIMITATION OF LIABILITY. TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT WILL WE BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF OR INABILITY TO
            USE THE WEBSITES AND/OR ANY CONTENT PROVIDED IN CONNECTION WITH THE WEBSITES OR FOR ANY OTHER CLAIM RELATED IN ANY WAY TO YOUR USE OF THE WEBSITES AND/OR ANY CONTENT. ADDITIONALLY, WE SHALL NOT BE LIABLE FOR NEGATIVE
            REPERCUSSIONS TO ANY PARTY BASED ON THE USE OF OR INABILITY TO USE THE WEBSITES, INCLUDING BUT NOT LIMITED TO LOST GOODWILL OR LOST PROFITS. WE SHALL BE LIABLE ONLY TO THE EXTENT OF ACTUAL DAMAGES INCURRED BY YOU, NOT TO EXCEED
            THE AMOUNT YOU ACTUALLY PAID TO US FOR GOODS OR SERVICES IN THE PRIOR SIX (6) MONTHS, IF ANY. WE ARE NOT LIABLE FOR ANY PERSONAL INJURY, INCLUDING DEATH, OR PROPERTY DAMAGE CAUSED BY YOUR USE OR MISUSE OF THE WEBSITES, THE
            CONTENT AND/OR THE USER CONTENT. REMEDIES UNDER THESE EULA ARE EXCLUSIVE AND ARE LIMITED TO THOSE EXPRESSLY PROVIDED FOR IN THESE EULA. BECAUSE SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY
            FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH STATES OR JURISDICTIONS OUR LIABILITY WILL BE LIMITED TO THE GREATEST EXTENT PERMITTED BY APPLICABLE LAW
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">c.</div>
          <div class="col px-0">
            INDEMNIFICATION. You agree to defend, indemnify, and hold Jikia harmless and our directors, officers, employees, and agents from and against any and all claims, demands, suits, proceedings, liabiliKes, judgments, losses,
            damages, expenses, and costs (including without limitaKon reasonable agorneys’ fees) assessed or incurred by us, directly or indirectly, with respect to or arising out of: (i) your failure to comply with these EULA; (ii) your
            breach of your obligaKons under these EULA; (iii) your use of Websites including your Content; and/or (iv) any claim that your Content caused damage to a third party.
          </div>
        </div>

        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>9.</b></div>
          <div class="col px-0">
            <b>JURISDICTION AND VENUE. </b>You agree that the Websites shall be deemed to be solely based in California, and that the Websites shall be deemed a passive website that does not give rise to personal jurisdicKon over Jikia in
            jurisdicKons other than California. These EULA shall be governed by and construed according to the laws of the State of California, without reference to its choice of law principles. Any claim or cause of acKon arising out of or
            relaKng to the Websites shall be brought in the state or federal courts located in the Central District of California and you hereby agree to the jurisdicKon and venue of those courts for any such dispute. Any such claim or
            cause of acKon shall be barred permanently unless such claim or cause of acKon is brought within one year aler it arises. If (i) you are not a U.S. ciKzen; (ii) you do not reside in the U.S.; (iii) you are not accessing the
            Service from the U.S.; or (iv) you are a ciKzen of one of the countries idenKfied below, you hereby agree that any dispute or claim arising from this Agreement shall be governed by the applicable law set forth below, without
            regard to any conflict of law provisions, and you hereby irrevocably submit to the non-exclusive jurisdicKon of the courts located in the state, province or country idenKfied below whose law governs: If you are a ciKzen of any
            European Union country or Switzerland, Norway or Iceland, the governing law and forum shall be the laws and courts of your usual place of residence.
          </div>
        </div>
        <div class="row mx-0 mt-3 ml-3 mr-3 text-justify">
          <div class="col-auto pl-0 pr-2"><b>10.</b></div>
          <div class="col px-0"><b> MISCELLANEOUS </b></div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">a.</div>
          <div class="col px-0">
            InterpretaKon of EULA. Where possible, these EULA shall be interpreted in such manner as to be effecKve and valid under applicable law. Should any part of these EULA for any reason be declared invalid or void, such decision
            shall not affect the remaining porKon which will remain in full force and effect.
          </div>
        </div>

        <div class="row mx-0 ml-5 mr-5 mt-2 text-justify">
          <div class="col-auto pl-0 pr-2">b.</div>
          <div class="col px-0">
            Entrie Agreement. This is the enKre agreement between us relaKng to your use of the Website and supersedes any prior understandings or agreements, wrigen or oral. These EULA may not be modified by you, in wriKng or otherwise,
            unless agreed to in a wrigen document signed by Jikia.
          </div>
        </div> -->

<!-- <h6 class="bold">END USER LICENSE AGREEMENT</h6>
        <p class="text-justify">
          The following END USER LICENSE AGREEMENT (the “EULA”) governs the use of Jikia (“we,” “our,” or “us”)
          websites, located at www.keeku.com, or parKcipaKng in any online features, services and/or programs
          offered by us (collecKvely, the “Website”). This EULA is in effect for all of our Websites.
        </p>
        <br />
        <h6 class="bold">BY ACCESSING OR USING OUR WEBSITES, YOU ARE ENTERING INTO A LEGAL
          CONTRACT WITH JIKIA REGARDING YOUR USE OF THE WEBSITES AND YOU AGREE TO
          BE BOUND BY THIS EULA. IF YOU DO NOT AGREE TO ANY PORTION OF THIS EULA, YOU
          SHOULD NOT ACCESS OR OTHERWISE USE THE WEBSITE.
          YOU SHOULD CAREFULLY REVIEW THIS ENTIRE EULA. INCLUDED IN THIS LEGAL
          CONTRACT ARE (i) REQUIREMENTS THAT YOU PROVIDE TRUTHFUL, ACCURATE,
          CURRENT AND COMPLETE INFORMATION ABOUT YOUR IDENTITY; (ii) PROHIBITIONS
          ON ALLOWING ANYONE OR ANY ENTITY OTHER THAN YOURSELF USE OF YOUR USER
          ACCOUNT; AND (iii) TERMS CLEARLY INDICATING YOU ARE RESPONSIBLE FOR ANY
          LEGAL ISSUES CAUSED BY YOUR CONTENT OR YOUR USE OF THE WEBSITES.</h6>
        
        <h6 class="bold">TABLE OF CONTENTS</h6>

        <p class="text-justify">1. CONVENIENCE AND INFORMATION ONLY</p>
        <p class="text-justify">2. USER ACCOUNT</p>
        <p class="text-justify">3. ACCURATE AND TRUTHFUL INFORMATION</p>
        <p class="text-justify">4. ACCOUNT DEACTIVATION</p>
        <p class="text-justify">5. OBJECTIONABLE MATERIAL</p>
        <p class="text-justify">6. CONTENT</p>
        <p class="text-justify">7. OUR PARTICIPATION</p>
        <p class="text-justify">8. NO WARRANTIES, LIMITATIONS OF LIABILITY, YOUR INDEMNIFICATION OF US</p>
        <p class="text-justify">9. JURISDICTION AND VENUE</p>
        <p class="text-justify">10. MISCELLANEOUS</p>

        <br />
        <p class="text-justify">1.</p>
        <h6 class="bold">CONVENIENCE AND INFORMATION ONLY.</h6>
        <p class="text-justify">
          The Websites are provided to you as a convenience
          and for your informaKon only. By merely providing access to the Website, we do NOT guarantee,
          warrant or represent that:
        </p>
        <br />
        <p class="text-justify">a. Any materials, statements, reviews, raKngs, opinions, documents, images, graphics,
          logos, designs, audio, video, comments and any other informaKon provided from or on
          the Websites (collecKvely, the “Content”) is accurate or complete;</p>
          <p class="text-justify">b. The Content is up-to-date or current;</p>
          <p class="text-justify">c. We have any obligaKon to update any Content;</p>
          <p class="text-justify">d. We will keep your Content confidenKal or restrict third parKes from any use of your
            Content;</p>
          <p class="text-justify">e. Any use, copy, reproducKon, adaptaKon, publicaKon, performance, or audio recording of
            the Content is free from allegaKons, claims, or lawsuits, including those based on
            allegaKons of intellectual property infringement, libel or slanderous defamatory
            statements, and/or violaKons of the right of publicity, including personality rights, the
            use of one's idenKty, such as name, image, likeness, or other unequivocal idenKfiers;</p>
          <p class="text-justify">f. The Content is free from changes caused by a third party;</p>
          <p class="text-justify">g. Your access to the Website will be free from interrupKons, errors, viruses or other
            harmful components;</p>
          <p class="text-justify">h. No data breach will ever occur; and/or</p>
          <p class="text-justify">i. InformaKon transmiged through the Internet is secure, or that such transmissions are
            free from delay, interrupKon, intercepKon or error.</p>
          <p class="text-justify">2.</p>
          <h6 class="bold">USER ACCOUNT</h6>
          <p class="text-justify">To access the Website, we require you to select a username and password, and
            create a user account (“User Account”). User Accounts are unique to an individual real person.
            You are prohibited from creaKng or using a User Account on behalf of an enKty, organizaKon,
            group, non-profit, university or other educaKonal insKtuKon, poliKcal organizaKon, government
            or governmental agency or enKty, etc. In your User Account informaKon, you may designate or
            be required to designate affiliaKon with a such group; provided however, that use of your User
            Account is limited to you as an individual. The following shall apply to your User Account:</p>
            <p class="text-justify">a. We use reasonable precauKons to protect the privacy of your username, password, and
              User Account informaKon including your User IdenKty (defined in §3a below). You,
              however, are ulKmately responsible for protecKng your username, password, and User
              Account informaKon from disclosure to third parKes;</p>
            <p class="text-justify">b. You are not permiged to circumvent the use of required encrypKon technologies, if any;</p>  
            <p class="text-justify">c. You agree to (i) immediately noKfy us of any unauthorized use of your username,
              password, or User Account, or any other breach of security, and (ii) ensure that you exit
              from your User Account at the end of each session;</p>
            <p class="text-justify">d. Usernames and passwords are non-transferable, and all users are obligated to take
              preventaKve measures to prohibit any other person or enKty from accessing the
              Websites with his or her username, password, or other account informaKon</p>
            <p class="text-justify">3.</p>
            <h6 class="bold">ACCURATE AND TRUTHFUL INFORMATION</h6>
            <p class="text-justify">In creaKng and using your User Account for use on
              the Website, you agree to:</p>
            <p class="text-justify">a. Provide true, accurate, current, and complete informaKon about yourself (“User
              IdenKty”); and</p>
            <p class="text-justify">b. Maintain and promptly update your User IdenKty to keep it true, accurate, current, and
              complete.</p>
            <p class="text-justify">c. You agree that we may collect and use data and related informaKon, including but not
              limited to demographical informaKon, poliKcal informaKon, technical informaKon about
              your device, system and applicaKon solware, and peripherals, and that we may use this
              informaKon, as long as it is in a form that does not personally idenKfy you.</p>

              <p class="text-justify">4.</p>
              <h6 class="bold">ACCOUNT DEACTIVATION. </h6>
              <p class="text-justify">. We reserve the right to, suspend, deacKvate, terminate or cancel
                your User Account, and/or remove some or all of any Content associated in any way with your
                User Account in our sole discreKon, including for the following reasons: 
                </p>
 -->
<!-- </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-black mw-auto float-right mr-2" (click)="onAcceptTermAndCondition('false')">Deny</button>
        <button type="button" class="btn btn-black mw-auto float-right" (click)="onAcceptTermAndCondition('true')">Accept</button>
      </div>
    </div>
  </div> 
</div>-->

<div
  id="phoneNumberModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div
        class="modal-body"
        [ngClass]="{
          'p-sm-5': otpSent,
          'p-3': otpSent,
          'p-5': otpSent == false
        }"
      >
        <h3 class="text-center">Text Verification</h3>
        <div *ngIf="otpSent == false">
          <form
            class="row m-0 px-2 px-sm-4 pt-2 pt-sm-4 square-form needs-validation cx-standard-form"
            (ngSubmit)="(f.form.valid)"
            #f="ngForm"
            novalidate
            autocomplete="off"
          >
            <button
              aria-label="Close"
              class="close close-modal"
              data-dismiss="modal"
              type="button"
              (click)="resetData(f)"
            >
              <app-icon name="x"></app-icon>
            </button>
            <div
              *ngIf="otpResendCooldownMsg"
              class="col-md-12 my-2 alert alert-danger"
            >
              {{ otpResendCooldownMsg }}
              <button
                (click)="otpResendCooldownMsg = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div
              *ngIf="phoneChangeError"
              class="alert alert-danger col-md-12 my-2"
            >
              {{ phoneChangeError }}
              <button
                (click)="phoneChangeError = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div class="row m-0 mobile-input-with-flag">
              <label
                for="phoneNumber"
                class="col-12 m-0 pl-0 pb-2 control-label font-gray"
              >
                Enter your mobile number
                <span class="text-danger" aria-hidden="true">*</span></label
              >
              <div
                class="col-auto pl-0 form-group countryCode-flag mt-2 d-flex align-items-center"
              >
                <img
                  [src]="popupSelectedCountry.flagUrl"
                  class="country-flag-img"
                  *ngIf="popupSelectedCountry"
                />
                <img
                  src="assets/images/flag_placeholder.png"
                  class="country-flag-img"
                  *ngIf="!popupSelectedCountry"
                />
              </div>
              <div class="col pl-0 form-group mt-2">
                <div class="country-code-dropdown">
                  <button
                    type="button"
                    class="btn country-code-btn form-control"
                    (click)="toggleCountryDropdown($event)"
                  >
                    <span>{{
                      popupSelectedCountry
                        ? popupSelectedCountry.callingCode
                        : '+1'
                    }}</span>
                    <span class="dropdown-caret">▼</span>
                  </button>

                  <div
                    class="country-dropdown-menu"
                    *ngIf="countryDropdownOpen"
                    (click)="$event.stopPropagation()"
                  >
                    <div class="country-search-wrap cx-search-control">
                      <app-icon
                        name="search"
                        class="cx-search-control__icon"
                        aria-hidden="true"
                      ></app-icon>
                      <input
                        #popupCountrySearch
                        type="search"
                        class="form-control country-search-input cx-search-control__input"
                        placeholder="Search country..."
                        (input)="searchCountry($event)"
                        (click)="$event.stopPropagation()"
                      />
                      <button
                        *ngIf="countrySearchTerm"
                        type="button"
                        class="cx-search-control__clear"
                        (click)="
                          countrySearchTerm = '';
                          popupCountrySearch.value = '';
                          filterCountries();
                          $event.stopPropagation()
                        "
                        aria-label="Clear country search"
                      >
                        <app-icon name="x" aria-hidden="true"></app-icon>
                      </button>
                    </div>
                    <div class="country-list">
                      <a
                        class="country-item"
                        *ngFor="let country of filteredCountries"
                        (click)="
                          selectCountry(country, true); $event.preventDefault()
                        "
                      >
                        <img
                          [src]="country.flagUrl"
                          class="country-flag-img"
                          alt=""
                        />
                        <span class="country-name">{{ country.name }}</span>
                        <span class="country-code">{{
                          country.callingCode
                        }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-8 col-md-7 pl-0 form-group mt-2">
                <input
                  type="text"
                  class="form-control min-width-20ch"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  [(ngModel)]="phoneNumber"
                  mask="(000) 000-0000"
                  inputmode="tel"
                  required
                  minlength="10"
                />
                <div *ngIf="f.submitted" class="invalid-feedback">
                  <span *ngIf="f.submitted && f.invalid">
                    Please enter valid phone number
                  </span>
                  <span *ngIf="invalidPhone == true">
                    Invalid Phone Number.</span
                  >
                  <span *ngIf="existPhoneNumber == true"
                    >This phone number is already verified. Please use different
                    number.</span
                  >
                </div>
              </div>
              <div class="col-md-12 pt-md-5 pt-4 text-center">
                <input
                  type="submit"
                  class="btn btn-black disable-btn"
                  (click)="sendOTP(f.invalid)"
                  [disabled]="otpResendBlocked || otpSendInFlight"
                  value="Send Code"
                />
              </div>
              <div class="col-md-12 pt-3 px-0">
                <p class="font-14">
                  By clicking Send Code, you consent to receive a one-time
                  verification code via SMS from CitizeX. Message and data rates
                  may apply. Message frequency: 1 msg/request. Text STOP to
                  cancel or HELP for help. Link to our
                  <a class="p-0" routerLink="/privacy-and-policy">
                    <b>Privacy Policy </b></a
                  >and
                  <a class="p-0" routerLink="/terms-and-conditions">
                    <b>Terms & Conditions</b></a
                  >.
                </p>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="otpSent">
          <form
            class="row m-0 px-2 px-sm-5 pt-2 pt-sm-5 square-form needs-validation cx-standard-form"
            (ngSubmit)="onSubmit(f)"
            #f="ngForm"
            novalidate
            autocomplete="off"
          >
            <button
              aria-label="Close"
              class="close close-modal"
              data-dismiss="modal"
              type="button"
              (click)="resetData(f)"
            >
              <app-icon name="x"></app-icon>
            </button>
            <div
              *ngIf="otpResent && !otpResendBlocked"
              class="col-md-12 my-2 alert alert-info"
            >
              OTP sent again.
              <button
                (click)="otpResent = false"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div
              *ngIf="phoneChangeError"
              class="alert alert-danger col-md-12 my-2"
            >
              {{ phoneChangeError }}
              <button
                (click)="phoneChangeError = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div
              *ngIf="otpResendCooldownMsg"
              class="col-md-12 my-2 alert alert-danger"
            >
              {{ otpResendCooldownMsg }}
              <button
                (click)="otpResendCooldownMsg = ''"
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span class="text-danger"
                  ><app-icon
                    name="x"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon
                ></span>
              </button>
            </div>
            <div class="col-12">
              <label
                for="input"
                class="col-12 m-0 text-center control-label font-16 font-gray"
                >Enter Code</label
              >
              <div class="col-10 mx-auto mt-3 d-flex justify-content-center">
                <ng-otp-input
                  [config]="otpConfig"
                  (onInputChange)="onOtpChange($event)"
                ></ng-otp-input>
              </div>

              <div
                class="text-center mt-2 invalid-feedback d-block"
                *ngIf="f.submitted"
              >
                <!-- invalid-feedback -->
                <span *ngIf="f.submitted && this.otpCode == ''">
                  Please enter verification code sent to your registered phone
                  number.
                </span>
                <span *ngIf="invalidOTP">
                  {{ otpVerificationError || 'Invalid OTP.' }}
                </span>
              </div>
            </div>
            <!-- .col -->

            <div class="col-md-12 pt-md-5 pt-4 text-center">
              <button type="submit" class="btn btn-black mt-2" tabindex="5">
                Continue
              </button>
              <p class="font-14 font-gray mt-3">
                Didn't get verification code?
                <button
                  type="button"
                  (click)="resendOTP(f)"
                  class="btn btn-link btn-link-theme font-14 p-0"
                  tabindex="6"
                  [disabled]="otpResendBlocked || otpSendInFlight"
                >
                  &nbsp;Resend now
                </button>
              </p>
              <p class="font-14 font-gray mt-3">
                Want to change number?
                <button
                  type="button"
                  (click)="changePhoneNumber()"
                  class="btn btn-link btn-link-theme font-14 p-0"
                  tabindex="7"
                >
                  &nbsp;Click here
                </button>
              </p>
            </div>
            <!-- .col -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  id="identityVerificationSignupModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="identityVerificationSignupModalTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body p-5">
        <button
          aria-label="Close"
          class="close close-modal"
          data-dismiss="modal"
          type="button"
        >
          <app-icon name="x"></app-icon>
        </button>
        <h3 id="identityVerificationSignupModalTitle" class="text-center">
          Didit Verification
        </h3>
        <p class="mb-0 mt-3 text-center text-muted">
          Preparing your secure identity verification session...
        </p>
      </div>
    </div>
  </div>
</div>

<!------------------Auto-Sign-in-Modal------------------>
<div
  class="modal fade"
  id="signupVerificationModal"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <!-- <p class="fw-600 mb-2">CitizeX does not store any personal information you upload for identity verification.
          We use an industry leading third-party service called Didit <a href="https://didit.me/" class="fw-700"
            target="_blank">(didit.me) </a>.
          You can read their personal data retention policy here: <a href="https://didit.me/terms/privacy-policy/"
            class="fw-700" target="_blank">didit.me/terms/privacy-policy/</a>.</p>
          <p class="fw-600 mb-2">Our platform requires every user to identify who they are through an ID verification process. 
            CitizeX aims to create a space where contributors are who they say they are, with no interference 
            from fake accounts or bots. Our goal is to provide a space where elected officials and constituents can 
            discuss the issues in a completely verified setting.</p>
          <p class="fw-600">Rest assured that your information is encrypted, private, and protected. 
            We’ll never sell your personal information or give access to a third party. 
            We will use your ID to verify your identity, and 
            we’ll match your address to verify which elected officials represent you.</p> -->
        <p class="fw-700 mb-2 font-16">
          Our platform requires every user to identify who they are through an
          ID verification process
        </p>
        <p class="fw-600 mb-2">
          CitizeX aims to create a space where contributors are who they say
          they are, with no interference from fake accounts or bots. Our goal is
          to provide a space where elected officials and constituents can
          discuss the issues in a completely verified setting.
        </p>
        <p class="fw-600 mb-2">
          Rest assured that your information is encrypted, private, and
          protected. We’ll never sell your personal information or give access
          to a third party. We will use your ID to verify your identity, and
          we’ll match your address to verify which elected officials represent
          you.
        </p>
        <p class="fw-600 mb-2">
          CitizeX does not store any personal information you upload for
          identity verification. We use an industry leading third-party service
          called Didit
          <a
            href="https://didit.me/"
            class="fw-700"
            target="_blank"
            rel="noopener noreferrer"
            >(didit.me) </a
          >. You can read their personal data retention policy here:
          <a
            href="https://didit.me/terms/privacy-policy/"
            class="fw-700"
            target="_blank"
            rel="noopener noreferrer"
            >didit.me/terms/privacy-policy/</a
          >.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-outline-black mt-4 mb-2 py-1 font-16 px-2 auto-signin-btn"
            data-dismiss="modal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
